import { render, staticRenderFns } from "./PolygonDisplay.vue?vue&type=template&id=2ade638c&scoped=true"
import script from "./PolygonDisplay.vue?vue&type=script&lang=js"
export * from "./PolygonDisplay.vue?vue&type=script&lang=js"
import style0 from "./PolygonDisplay.vue?vue&type=style&index=0&id=2ade638c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.108.4_postcss@8.5.19___ejs@3.1.10_lodash@4.18._z5rsh3vccqgauevuorosu7p4fm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ade638c",
  null
  
)

export default component.exports